import "./multi-column-rich-text.scss";

import { ReactNode } from "react";
import cn from "clsx";
import {
  ComponentHeader,
  ComponentHeaderProps,
} from "design-system/components/primitives/component-header/component-header";
import { Alignment } from "design-system/types/types";

export interface MultiColumnRichTextProps {
  headerContent?: ComponentHeaderProps;
  content?: ReactNode;
  align?: Exclude<Alignment, "full">;
  HeadingLevel?: "h2" | "h3";
}

export function MultiColumnRichText({
  headerContent,
  content,
  align = "center",
  HeadingLevel = "h2",
}: MultiColumnRichTextProps) {
  if (!content) return null;

  const wrapperClass = cn(
    `hbs-global-align-${align}`,
    "hbs-multi-column-rich-text",
  );

  return (
    <div className={wrapperClass}>
      {headerContent && (
        <ComponentHeader {...headerContent} HeadingLevel={HeadingLevel} />
      )}
      {content && (
        <div
          className={cn(
            "hbs-multi-column-rich-text__content",
            headerContent && "hbs-multi-column-rich-text__content--with-border",
          )}
        >
          {content}
        </div>
      )}
    </div>
  );
}
